import {
    requestLogin,
    requestVerifyCode,
    requestCreateUser
} from '../requests/auth';
import { call, put, select} from "redux-saga/effects";
import { setAuthData, setUserData , setRequestLogin, setError, setLoaderState, setErrorMessage, setErrorCode } from '../../duck/auth';
import { getProviderSearchData } from '../../duck/provider';

export function* handleRequestLogin(action) {
    try {
        yield put(setLoaderState(true));
        yield put(setAuthData(false));
        const response = yield call(requestLogin, action.payload);
        yield put(setRequestLogin(true));
        yield put(setLoaderState(false));
    } catch (error) {
        yield put(setLoaderState(false));
        yield put(setError(true));
        if( error.response.data.error.errorCode === 4004 )
        {
            yield put(setErrorCode(error.response.data.error.errorCode));
            yield put(setErrorMessage(error.response.data.error.errorMessages[0]))
        }
        else{
            yield put(setErrorMessage("Something went Wrong!"))
        }
    }
}
export function* handleVerifyCode(action) {
    try {
        const { providerSearchQueryByAddress } = yield select((state => state.provider));
        yield put(setRequestLogin(false));
        yield put(setAuthData(false));
        yield put(setLoaderState(true));
        const response = yield call(requestVerifyCode, action.payload);
        const { data } = response;
        sessionStorage.setItem("loginToken", data.item.userToken)
        yield put(setRequestLogin(true));
        yield put(setAuthData(true));
        yield put(setLoaderState(false));
        yield put(getProviderSearchData(providerSearchQueryByAddress))
    } catch (error) {
        yield put(setLoaderState(false));
        yield put(setError(true));
        if(error.response.data.error.errorCode === 4011 || error.response.data.error.errorCode === 400  )
        {
            yield put(setErrorCode(error.response.data.error.errorCode));
            yield put(setErrorMessage(error.response.data.error.errorMessages[0]))
        }
        else{
            yield put(setErrorMessage("Something went Wrong!"))
        }
        
    }
}
export function* handleCreateUser(action) {
    try {
        yield put(setUserData(false));
        yield put(setLoaderState(true));
        const response = yield call(requestCreateUser, action.payload);
        yield put(setUserData(true));
        yield put(setLoaderState(false));
    } catch (error) {
        yield put(setLoaderState(false));
        yield put(setError(true));
        if(error.response.data.error.errorCode ===4010)
        {
            yield put(setErrorMessage(error.response.data.error.errorMessages[0]))
        }
        else{
            yield put(setErrorMessage("Something went Wrong!"))
        }
        
    }
}